import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/benefits/networking/Networking.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/Networking/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Benefits/Networking/components/SectionPitch'));
const SectionCards = dynamic(() => import('sections/Benefits/Networking/components/SectionCards'));
const SectionFaq = dynamic(() => import('sections/Benefits/Networking/components/SectionFaq'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Benefits/Networking/components/SectionForm'));

type NetworkingProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function NetworkingPage({ pageTitle, formUrl, leadSubtype }: NetworkingProps) {
  return (
    <div className={cn('networking')}>
      <SectionHeader />
      <SectionPitch />
      <SectionCards />
      <SectionFaq />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
    </div>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component on all Benefits pages as an additional data: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.networking.pageTitle,
  //   formUrl: LeadFormParameters.networking.formUrl,
  //   leadSubtype: LeadFormParameters.networking.leadSubtype,
  // };

  return {
    props: {
      title: 'Freight Networking Opportunities | DF Alliance',
      description:
        'Unlock the power of networking with DF Alliance. Connect with a vast network of professionals and partners in the logistics and freight forwarding industry.',
      path: '/benefits/networking',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

NetworkingPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
